import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import OuvidoriaService from '../../../../services/ouvidoria';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [dataIn, setDataIn] = useState("");
    const [dataFt, setDataFt] = useState("");
    const [palavra, setPalavra] = useState("");
    const [situacao, setSituacao] = useState("");

    const busca = async (query) => {
        if (query == "") {
            props.setVazio(true)
        } else {
            var response = await OuvidoriaService.buscarSigilo(query)
            if (response.data.length >= 1) {
                props.setRequisicoes(response.data)
                props.setVazio(false)
            } else {
                props.setVazio(true)
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery;
        if (palavra) prepQuery = prepQuery + `&palavra=${encodeURI(palavra)}`;
        if (situacao !== "false" && situacao !== "") prepQuery = prepQuery + `&situacao=${encodeURI(situacao)}`;
        if (dataIn) prepQuery = prepQuery + `&dataIn=${dataIn}`;
        if (dataFt) prepQuery = prepQuery + `&dataFt=${dataFt}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={3}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Palavra-chave">
                                <FloatingLabel
                                    label="Palavra-chave"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="palavra"
                                        value={palavra}
                                        onChange={e => setPalavra(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="situacao">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="situacao"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Pendente">Pendente</option>
                                        <option value="Recebido pela Prefeitura">Recebido pela Prefeitura</option>
                                        <option value="Encaminhada à Secretaria Responsável">Encaminhada à Secretaria Responsável</option>
                                        <option value="Secretaria Responsável está atuando">Secretaria Responsável está atuando</option>
                                        <option value="Respondido">Respondido</option>
                                        <option value="Resolvido">Resolvido</option>
                                        <option value="1º Recurso">1º Recurso</option>
                                        <option value="2º Recurso">2º Recurso</option>
                                        <option value="Último Recurso">Último Recurso</option>
                                        <option value="Encaminhado à Autoridade Superior">Encaminhado à Autoridade Superior</option>
                                        <option value="Encerrado">Encerrado</option>
                                        <option value="Indeferido, justificado via mensagem">Indeferido, justificado via mensagem</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataInicial">
                                <FloatingLabel
                                    label="Data Inicial"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataIn"
                                        value={dataIn}
                                        onChange={e => setDataIn(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataft">
                                <FloatingLabel
                                    label="Data Final"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataFt"
                                        value={dataFt}
                                        onChange={e => setDataFt(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/ouvidoria'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <br/>
                     <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.requisicoes} nome={"Requisicoes"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#adff4e89-594d-4390-ba25-7791d02f5186" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
